// extracted by mini-css-extract-plugin
export default {"rootSlide":"SwiperSlideDev_rootSlide__6tu3z","swiper":"SwiperSlideDev_swiper__1n3Qj","swiper-slide":"SwiperSlideDev_swiper-slide__g3esa","mySwiper":"SwiperSlideDev_mySwiper__MVbef"};